export default __webpack_public_path__ + "static/media/overview-char-dark.eca4ffd2.png";